import React from "react";

const Checkbox = ({ name, index, type, title, value, change }) => {
  return (
    <div className={`flex items-center${value ? " active" : ""}`}>
      <input
        type={type}
        value="Yes"
        id={`${name}-field-${index}`}
        checked={value}
        className="absolute opacity-0"
        onChange={(e) => change(index, e.target.checked)}
        autoFocus={index === 0 || index === 1}
      />
      <label
        htmlFor={`${name}-field-${index}`}
        className="inline-flex justify-between items-center checkbox-title text-lg font-medium leading-normal"
        dangerouslySetInnerHTML={{ __html: `<span>${title}</span>` }}
      />
    </div>
  );
};

export default Checkbox;
